<template>
	<div class="gratuity-wrapper">
		<div class="gratuity-title">Gratuity</div>
		<ul class="gratuity-list">
			<li
				v-for="option in options"
				:key="option.id"
				class="gratuity-list-item"
			>
				<button
					class="gratuity-option"
					:aria-label="'Select tip ' + option.label"
					:class="{ active: gratuityPercent == option.value }"
					type="button"
					@click="selectTip(option.value)"
				>
					{{ option.label }}
				</button>
			</li>
			<li class="gratuity-list-item">
				<button
					class="gratuity-option"
					aria-label="Select custom tip."
					:class="{
						active: selectedAmount === '-1' || isCustomTip,
					}"
					type="button"
					@click="selectCustomTip()"
				>
					OTHER
				</button>
			</li>
		</ul>
		<div v-if="isCustomTip" class="custom-gratuity">
			<label for="custom-tip">Set Custom Tip Amount: $</label>
			<input :aria-label="`Set Custom Tip Amount $${customTipAmount}`" id="custom-tip" v-model="customTipAmount" />
			<button
				id="submitTip"
				:aria-label="'Submit custom tip $' + customTipAmount"
				@click="submitCustomTip('-1')"
			>
				Submit
			</button>
		</div>
		<div v-if="message" class="gratuity-message">{{ message }}</div>
	</div>
</template>

<script>
const debounce = require("lodash/debounce");

export default {
	name: "CartGratuityPicker",
	props: {
		options: {
			type: Array,
			default: () => [],
		},
		message: {
			type: String,
		},
		gratuityPercent: {
			type: [String, Number],
		},
		gratuityAmount: {
			type: [String, Number],
		},
	},
	data: function () {
		return {
			selectedAmount: this.gratuityPercent,
			customTipAmount:
				this.gratuityPercent === "-1" ? this.gratuityAmount : null,
			isCustomTip: this.gratuityPercent === "-1" ? true : false,
		};
	},
	methods: {
		selectTip: debounce(
			function (value) {
				if (value === this.selectedAmount) {
					return false;
				}
				this.isCustomTip = false;
				this.selectedAmount = value;
				this.$emit("gratuity-change", { value: value });
			},
			1000,
			{ leading: true, trailing: false }
		),
		selectCustomTip() {
			this.isCustomTip = true;
			this.selectedAmount = "-1";
			this.customTipAmount = this.gratuityAmount;
		},
		submitCustomTip: debounce(
			function (value) {
				this.selectedAmount = value;
				if (isNaN(this.customTipAmount) || !this.customTipAmount) {
					return false;
				}
				this.$emit("gratuity-change", {
					value: value,
					customTipAmount: this.customTipAmount,
				});
			},
			1000,
			{ leading: true, trailing: false }
		),
	},
};
</script>

<style lang="scss" scoped>
.gratuity-wrapper {
	margin-bottom: 20px;
}

.gratuity-title {
	font-weight: 700;
	font-size: 1.4rem;
	margin-bottom: 5px;
	text-align: center;
}

.gratuity-list {
	display: flex;
	flex-wrap: wrap;
	margin: -5px -2.5px 20px;
}

.gratuity-list-item {
	padding: 5px 2.5px 0;
	flex: 1 1 auto;
}

.gratuity-option {
	@include transition(border-color);
	font-size: 1.1rem;
	font-weight: 700;
	background-color: $gray_4;
	border: 2px solid $gray_4;
	border-radius: 15.5px;
	padding: 5px 20px;
	width: 100%;

	&:hover,
	&:focus,
	&.active {
		border-color: $tomato;
	}
}

.gratuity-message {
	text-align: center;
	font-weight: 500;
	font-size: 1.2rem;
}

.custom-gratuity {
	margin-bottom: 10px;
	text-align: center;
	font-weight: 500;
	font-size: 1.6rem;
}

#custom-tip {
	border: 2px solid;
	width: 20%;
	margin-right: 10px;
}

#submitTip {
	background-color: #0184c6;
	color: white;
	padding: 5px 25px 5px 25px;
	border-radius: 15.5px;
}
</style>